import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

import { NagNameAlias } from 'app/services/nag.service';

export interface NagAliasModalData {
	action: 'add' | 'edit';
	alias?: NagNameAlias;
}

@Component({
	selector: 'app-nag-alias-modal',
	templateUrl: './nag-alias-modal.component.html',
	styleUrls: ['./nag-alias-modal.component.css', './../nag-standard-modal/nag-standard-modal.component.css']
})
export class NagAliasModalComponent implements OnInit {

	public title: string;
	public aliasName: string;

	showDelete: boolean;
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: NagAliasModalData,
		public dialogRef: MatDialogRef<NagAliasModalComponent>
	) { }

	cancel() {
		this.dialogRef.close(null);
	}
	apply() {
		// Close modal
		this.dialogRef.close(this.aliasName);
	}
	deleteAlias() {
		this.dialogRef.close({
			delete: true
		});
	}
	ngOnInit() {
		this.title = this.data.action === 'add' ? 'New Alias' : 'Update Alias';
		this.showDelete = this.data.action !== 'add';
		this.aliasName = this.data.alias ? this.data.alias.name : '';
	}

}
